export const BET_CONTACT_SUMMARY_TAB = 'contactSummary';
export const BET_CUSTOMER_SUMMARY_TAB = 'customerSummary';
export const BET_RENEWAL_SUMMARY_TAB = 'renewalSummary';
export const PARTNER_SHARED_ACTIVITIES_TAB = 'partnerSharedActivities';
export const CALL_SUMMARY_TAB = 'callSummary';
export const BET_TABS = [BET_CONTACT_SUMMARY_TAB, BET_CUSTOMER_SUMMARY_TAB, BET_RENEWAL_SUMMARY_TAB, PARTNER_SHARED_ACTIVITIES_TAB, CALL_SUMMARY_TAB];